export const doLogout = (navigate) => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("adminYn");
  window.dispatchEvent(new Event("nava-logout"));
  if (navigate) navigate("/");
};
